// @flow

import {
  LOAD_ORGANIZATIONS,
  ORGANIZATIONS_LOADED,
  ORGANIZATION_UPDATE,
  ORGANIZATION_UPDATE_DONE,
  ORGANIZATION_ADD,
  ORGANIZATION_ADD_DONE,
  ORGANIZATIONS_RESET_LOADING,
  ORGANIZATION_UPDATE_BRANDING,
  ORGANIZATION_UPDATE_BRANDING_DONE,
  LOG_OUT,
  LOAD_ORGANIZATION_DONE,
  LOAD_ORGANIZATION,
  LOADING_ORGANIZATION
} from "../actions/actionTypes";
import { findWithAttr } from "../../utils/utils";
import { REHYDRATE } from "redux-persist";

const initialState = {
  loading: false,
  // last page loaded
  page: 0,
  // is there need to load more, currently determined
  // to be false if last page listing returned no results
  loadMore: true,
  list: []
};

const organizationsReducer = (state = initialState, action) => {
  let list, index;

  switch (action.type) {
    case ORGANIZATIONS_RESET_LOADING:
      return initialState;

    case LOAD_ORGANIZATIONS:
    case LOADING_ORGANIZATION:
      return { ...state, loading: true };

    case ORGANIZATION_UPDATE:
    case ORGANIZATION_ADD:
      return { ...state, submitting: true };

    case ORGANIZATION_UPDATE_BRANDING:
    case LOAD_ORGANIZATION:
      return { ...state, loading: true };

    case LOAD_ORGANIZATION_DONE:
      return { ...state, loading: false, organizationSingle: action.data };

    case ORGANIZATION_UPDATE_DONE:
    case ORGANIZATION_ADD_DONE:
    case ORGANIZATION_UPDATE_BRANDING_DONE:
      list = state.list.slice(0);
      index = findWithAttr(list, "id", action.data.id);
      let organizationSingle = action.data;
      if (index === -1) {
        list = list.concat([action.data]);
      } else {
        list[index] = action.data;
      }

      return {
        ...state,
        loading: false,
        submitting: false,
        organizationSingle: organizationSingle,
        list: list
      };

    case ORGANIZATIONS_LOADED:
      // console.log('ORGTEST', action);
      const newState = {
        ...state,
        loading: false,
        page: action.page,
        loadMore: action.loadMore,
        list:
          action.page === 1
            ? action.list
            : state.list.slice(0).concat(action.list)
      };
      // console.log('REDUCER ORGANIZATIONS ', newState);
      return newState;

    case LOG_OUT:
      return initialState;

    case REHYDRATE:
      if (action.payload && action.payload.organizations) {
        return { ...state, ...action.payload.organizations, loading: false };
      }
      return state;

    default:
      return state;
  }
};

export default organizationsReducer;
